import { useEffect, useRef } from 'react';

export interface MeasurerProps {
    children?: React.ReactNode;
    identifier: string | number;
    onSizeChange: (identifier: string | number, dimensions: { height: number; width: number }) => void;
}

const Measurer = ({ identifier, onSizeChange, children }: MeasurerProps) => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (ref.current) {
            const { height, width } = ref.current.getBoundingClientRect();
            onSizeChange(identifier, { height, width });
        }
    }, [identifier, onSizeChange, children]);

    return <div ref={ref}>{children}</div>;
};
export default Measurer;
